import { useCallback, useState } from "react";

const useStateSorted = <T>(defaultValue: T[], sortKey: keyof T) => {
  const [state, setState] = useState<T[]>(defaultValue);

  const setSortedState = useCallback((items: T[]) => {
    if (!items) {
      setState(null);
      return;
    }

    const sorted = [...items].sort((a, b) => {
      const aVal = a[sortKey];
      const bVal = b[sortKey];

      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return aVal.localeCompare(bVal);
      }

      return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
    });

    setState(sorted);
  }, [sortKey]);

  return [state, setSortedState] as const;
};

export default useStateSorted;
